import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Select, Input, InputNumber, Modal, message } from 'hljd'
import Upload from '../../Upload'
import SearchInput from '../SearchInput'
import { observer } from 'mobx-react'
import moment from 'moment'
import { toJS } from 'mobx'
import style from '@components/JiaMeng/NewCustomer/style/modal.css'

const FormItem = Form.Item
const Option = Select.Option
const { TextArea } = Input

@Form.create()
@observer
class SignModal extends Component {
  handleOk = () => {
    const { store, form } = this.props
    const { createSign } = store
    const fieldValue = form.getFieldsValue()

    if (!fieldValue.property_id) {
      return message.warning('请填写需求类型')
    }
    if (!fieldValue.set_meal_id) {
      return message.warning('请填写商品名称')
    }
    if (!fieldValue.total_money) {
      return message.warning('请填写签单总金额')
    }
    if (!fieldValue.remark) {
      return message.warning('请填写备注')
    }

    const value = {
      ...fieldValue,
      attachments: JSON.stringify(fieldValue.attachments)
    }
    if (fieldValue.remind_time) {
      value.remind_time = moment(value.remind_time).format(__FMT2__)
    }
    const searchResult = toJS(store.searchResult)
    const index = searchResult.findIndex(item => item.id === value.set_meal_id)
    if (index < 0) {
      value.set_meal_title = value.set_meal_id
      value.set_meal_id = ''
    } else {
      value.set_meal_title = searchResult[index].title
    }
    createSign(value)

    form.resetFields()
  }

  render() {
    const {
      store,
      propertyList,
      form: { getFieldDecorator }
    } = this.props

    const { signModalVisible, setStoreData } = store

    return (
      <Modal
        title="签单"
        visible={signModalVisible}
        onOk={this.handleOk}
        onCancel={() =>
          setStoreData([{ type: 'signModalVisible', value: false }])
        }
        width={400}
        wrapClassName={style.modal}
      >
        <Form className={style.form}>
          <FormItem label="需求类型">
            {getFieldDecorator('property_id')(
              <Select placeholder="请选择">
                {propertyList.map((item, index) => {
                  return (
                    <Option key={index} value={item.id}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            )}
          </FormItem>
          <FormItem label="商品名称">
            {getFieldDecorator('set_meal_id', {
              initialValue: ''
            })(<SearchInput store={store} onSearch={store.onSearch} />)}
          </FormItem>
          <FormItem label="签单总金额">
            {getFieldDecorator('total_money', {
              initialValue: ''
            })(<InputNumber min={0} />)}
          </FormItem>
          <FormItem label="备注">
            {getFieldDecorator('remark')(<TextArea />)}
          </FormItem>
          <FormItem label="附件">
            {getFieldDecorator('attachments', {
              initialValue: []
            })(<Upload />)}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

export default SignModal
